export default {
    methods: {
        getInstructionLink: function(name, lang) {
            let link;
            let deDoc = '/docs/2024-04 Struktur Dashboard - Händler V2.pdf';
            let enDoc = '/docs/2024-04 Dashboard  Structure - Sellers V2 (ENGL).pdf';

            if (lang === 'de') {
                link = deDoc + "#";
                switch (name) {
                    case "user.edit" : link += "h.wlesuy8hfaj0"; break;
                    case "orders.index" :
                    case "orders.index.store" : link += "h.o7g8g6w5ynod"; break;
                    case "stores.index" : link += "h.z4f3rfylfofj"; break;
                    case "stores.create" : link += "h.e4a9eaefora"; break;
                    case "store.edit.basic" : link += "h.uc0vclu4zu6"; break;
                    case "store.edit.opening-hours" : link += "h.nsbgrte77wp1"; break;
                    case "store.edit.logo" : link += "h.o4cptszfrdja"; break;
                    case "store.edit.images" : link += "h.elruzfs3o3l9"; break;
                    case "store.edit.social-media" : link += "h.5nbjfv2n5yte"; break;
                    case "store.edit.parking" : link += "h.6jlsxgr7bqtl"; break;
                    case "store.edit.payment" : link += "h.e9tezxkcougx"; break;
                    case "store.edit.brands" : link += "h.ke9s4owav4vx"; break;
                    case "store.edit.users" : link += "h.dss81vubxhcq"; break;
                    case "store.edit.roles" : link += "h.ox4vje5z40gt"; break;
                    case "store.edit.invoice" : link += "h.jl735irg586g"; break;
                    case "store.edit.sale" : link += "h.53we5msiiem6"; break;
                    case "store.edit.reservations" : link += "h.e7c73ksvbc48"; break;
                    case "store.articles.index" : link += "h.bfj9mvwzz0c3"; break;
                    case "article.create" : link += "h.sezrbl403syx"; break;
                    case "article.update.show" : link += "h.702x4yi20s35"; break;
                    case "offers" : link += "h.nsh81ofqaqib"; break;
                    case "stats.overview" : link += "h.5nbaz6lz9ei6"; break;
                    case "integrations.index" : link += "h.k6a2yv26phm3"; break;
                    case "ftp.account.settings" : link += "h.wqqk3s81grrp"; break;
                    case "ftp.connector.settings" : link += "h.sxceczdtsqs3"; break;
                    default: link = deDoc; break;
                }
            } else {
                link = enDoc + "#";
                switch (name) {
                    case "user.edit" : link += "h.wh9d2a9u9lhj"; break;
                    case "orders.index" :
                    case "orders.index.store" : link += "h.o7g8g6w5ynod"; break;
                    case "stores.index" : link += "h.z4f3rfylfofj"; break;
                    case "stores.create" : link += "h.e4a9eaefora"; break;
                    case "store.edit.basic" : link += "h.uc0vclu4zu6"; break;
                    case "store.edit.opening-hours" : link += "h.nsbgrte77wp1"; break;
                    case "store.edit.logo" : link += "h.o4cptszfrdja"; break;
                    case "store.edit.images" : link += "h.elruzfs3o3l9"; break;
                    // case "store.edit.social-media" : link += "h.5nbjfv2n5yte"; break;
                    case "store.edit.parking" : link += "h.6jlsxgr7bqtl"; break;
                    case "store.edit.payment" : link += "h.e9tezxkcougx"; break;
                    // case "store.edit.brands" : link += "h.ke9s4owav4vx"; break;
                    case "store.edit.users" : link += "h.dss81vubxhcq"; break;
                    case "store.edit.roles" : link += "h.ox4vje5z40gt"; break;
                    case "store.edit.invoice" : link += "h.jl735irg586g"; break;
                    case "store.edit.sale" : link += "h.53we5msiiem6"; break;
                    case "store.edit.reservations" : link += "h.e7c73ksvbc48"; break;
                    case "store.articles.index" : link +=  "h.bfj9mvwzz0c3"; break;
                    // case "article.create" : link +=  "h.sezrbl403syx"; break;
                    case "article.update.show" : link +=  "h.702x4yi20s35"; break;
                    // case "offers.index" : link += "h.nsh81ofqaqib"; break;
                    // case "stats.overview" : link += "h.5nbaz6lz9ei6"; break;
                    case "integrations.index" : link +=  "h.k6a2yv26phm3"; break;
                    case "ftp.account.settings" : link += "h.cgpgzf5yi8b0"; break;
                    case "ftp.connector.settings" : link += "h.rv8x2bw6596f"; break;
                    default: link = deDoc; break;
                }
            }

            return link;
        },
    },
};
